module.exports = require("node:stream");